import * as wasmBindgen from "../wasm/spr";
/**
 * Singlethreaded release build MmdWasmInstanceType with integrated bullet physics
 *
 * Requirements for use:
 *
 * - Browser that supports WebAssembly
 */
export class MmdWasmInstanceTypeSPR {
    getWasmInstanceInner() {
        return wasmBindgen;
    }
}
